import { useCarleadTimeTracking } from '../hooks/useTimeTracking';
export default function CarleadTimeTracking(_ref) {
  let {
    pageName
  } = _ref;
  useCarleadTimeTracking({
    page: pageName
  });
  return null;
}